export default "<p>\r\n  features works!\r\n</p>\r\n"